import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs';
import { AppState } from '../../core/app-state';
import { Market } from "../../core/models/market";
import { MarketService } from "../../core/services/market.service";
import { ConfirmModalComponent } from "../../shared/components/confirm-modal/confirm-modal.component";
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { MarketEditComponent } from "../market-edit/market-edit.component";

@Component({
  selector: 'app-rxdb-markets-view',
  templateUrl: './rxdb-markets-view.component.html',
  styleUrls: ['./rxdb-markets-view.component.css']
})
export class RxdbMarketsViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  isLoading : boolean = false;
  errorMsg: string = "";
  bSyncing: boolean = false;

  constructor(appState: AppState,
    private marketsService : MarketService,
    private bsModalService: BsModalService) {
    super(appState)
  }

  ngOnInit(): void {
    this.loadMarkets()
  }

  ngOnDestroy(): void {
    this.destroy()
  }

  markets : Market[] = []

  async loadMarkets() {
    this.errorMsg = ""
    this.markets = []

    this.isLoading = true
    try {
      this.markets = await firstValueFrom(this.marketsService.getMarkets()) as Market[];
      this.markets.forEach((market)=>{
        market.description=this.marketsService.getSingleTimezoneText(market.timezone)
      })
    } catch ( error ) {
      this.errorMsg = this.marketsService.extractErrorMsg(error)
    }
    this.isLoading=false;
  }


  editMarket(market: Market=null) {
    const initialState = {
      onSaveMarket: async () => {
        await this.loadMarkets()
      },
      market: market?market:null
    }
    const modalRef = this.bsModalService.show(MarketEditComponent, {
      ignoreBackdropClick: false,
      class: 'modal-lg',
      initialState: initialState,
    });
    const marketEditComponent: MarketEditComponent = modalRef.content
    marketEditComponent.setMarket(market)
  }

  deleteMarket(market:Market)
  {

    let initialState = {
      onYes: () => {
        this.marketsService.deleteMarket(market.name).subscribe(async (data) => {
          this.appState.notifySuccess("Market has been deleted", AppState, 1000);
          await this.loadMarkets();
        },(error)=>{
          this.appState.notifyError(error.error.msg,AppState,1000)
        })
      },
      question: `Are you sure you wish to delete market  ${market.name}? `,
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    const modalRef=this.bsModalService.show(ConfirmModalComponent, { initialState });

  }

  getTimezone(timezone: string) {
    return this.marketsService.getSingleTimezoneText(timezone);
  }
}
